// removed by extract-text-webpack-plugin
module.exports = {"root":"root_1En9n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CheckboxButton/style.css
// module id = 224
// module chunks = 0